import WEBAPP_ROUTES from "@readai/common/routes";
import { getAppUrl } from "@readai/common/utils/urlUtils";

const ROUTES = {
  ROOT: "",
  NOT_FOUND: "/404",
  ERROR: "/500",

  EVENTS_ROOT: "/events",
  EVENT_NOT_FOUND: "/events/404",
  EVENT_ERROR: "/events/500",
};

const MAIN_APP = {
  SIGN_IN: getAppUrl(WEBAPP_ROUTES.SIGN_IN, { app: "main" }),
  SIGN_UP: getAppUrl(WEBAPP_ROUTES.SIGN_UP, { app: "main" }),
  LANDING_PAGE: getAppUrl(WEBAPP_ROUTES.LANDING_PAGE, { app: "main" }),
  SMART_SCHEDULER_SETTINGS: getAppUrl(
    WEBAPP_ROUTES.USER_SETTINGS_SMART_SCHEDULER,
    { app: "main" },
  ),
};

const PARAMETERIZED_ROUTES = {
  scheduleByVanityIds: (userVanityId: string, linkVanityId?: string) =>
    `${ROUTES.ROOT}/${userVanityId}${linkVanityId ? `/${linkVanityId}` : ""}`,
  eventById: (eventId: string) => `${ROUTES.EVENTS_ROOT}/${eventId}`,
  cancelEventById: (eventId: string) =>
    `${ROUTES.EVENTS_ROOT}/${eventId}/cancel`,
  eventEndedById: (eventId: string) => `${ROUTES.EVENTS_ROOT}/${eventId}/ended`,
};

export default {
  ...ROUTES,
  ...PARAMETERIZED_ROUTES,
  MAIN_APP,
};
